import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMaster } from "toolkit/features/master";
import { RootState } from "toolkit/store";
import useAuth from "./userAuth";

let lockApiCall = false

const useMaster = () => {
  const dispatch = useDispatch<any>();
  const token = useAuth();

  const { data, loading } = useSelector((state: RootState) => state.master);

  useEffect(() => {
    if (!data && token?.data?.t && !loading && !lockApiCall) {
      lockApiCall = true
      dispatch(getMaster({})).then(res=>{
        lockApiCall = false
      });
    }
  }, [token]);

  return { data, loading };
};

export default useMaster;
